"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructorGetDataByIds = constructorGetDataByIds;
exports.constructorGetData = constructorGetData;
exports.constructorGetFacets = constructorGetFacets;
exports.constructorGetAutocomplete = constructorGetAutocomplete;
exports.constructorGetRecommendations = constructorGetRecommendations;
const slugify_1 = require("../slugify");
const constants_1 = require("./constants");
const createConstructorInstances_1 = require("./createConstructorInstances");
function constructorGetDataByIds(_a) {
    return __awaiter(this, arguments, void 0, function* ({ ids, page = 1, resultsPerPage = 100, filters = {}, isServerSide, userId, }) {
        const constructorio = isServerSide && typeof window === 'undefined'
            ? (0, createConstructorInstances_1.getConstructorInstanceServerSide)({ userId })
            : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({ userId });
        return yield constructorio.browse.getBrowseResultsForItemIds(ids, {
            page,
            resultsPerPage,
            filters,
        });
    });
}
function constructorGetData(_a) {
    return __awaiter(this, arguments, void 0, function* ({ query = '', page = 1, resultsPerPage = 100, filters = {}, sortBy, sortOrder, selectedCategory = 'all', isServerSide, userId, filterByIds, }) {
        var _b, _c, _d, _e;
        try {
            const constructorio = isServerSide && typeof window === 'undefined'
                ? (0, createConstructorInstances_1.getConstructorInstanceServerSide)({ userId })
                : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({ userId });
            const slugifiedSelectedCategory = (0, slugify_1.slugify)(selectedCategory);
            const groupIdValue = constants_1.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER[slugifiedSelectedCategory] ||
                slugifiedSelectedCategory;
            const response = yield (() => __awaiter(this, void 0, void 0, function* () {
                if (filterByIds === null || filterByIds === void 0 ? void 0 : filterByIds.length) {
                    return constructorGetDataByIds({
                        ids: filterByIds,
                        page,
                        resultsPerPage,
                        filters,
                        isServerSide,
                        userId,
                    });
                }
                if (query === '') {
                    return constructorio.browse.getBrowseResults('group_id', groupIdValue, {
                        page,
                        resultsPerPage,
                        filters,
                        sortBy,
                        sortOrder,
                    });
                }
                return constructorio.search.getSearchResults(query, {
                    page,
                    resultsPerPage,
                    filters,
                    sortBy,
                    sortOrder,
                    // preFilterExpression: { // Nice example of how to use AND filters if necessary, we don't need it for now, but just in case
                    //   and: [
                    //     {
                    //       name: 'group_id',
                    //       value: 'prints',
                    //     },
                    //     // {
                    //     //   name: 'group_id',
                    //     //   value: 'paintings',
                    //     // },
                    //   ],
                    // },
                });
            }))();
            // console.log('Constructor Response data', response)
            if ('redirect' in response.response) {
                return {
                    type: 'redirect',
                    redirect: response.response.redirect,
                };
            }
            const requestFromConstructor = response.request;
            const responseFromConstructor = response.response;
            const dataFromConstructor = responseFromConstructor.results;
            const facetsFromConstructor = responseFromConstructor.facets;
            const totalNumResultsFromConstructor = (((_c = (_b = responseFromConstructor === null || responseFromConstructor === void 0 ? void 0 : responseFromConstructor.result_sources) === null || _b === void 0 ? void 0 : _b.token_match) === null || _c === void 0 ? void 0 : _c.count) || 0) +
                (((_e = (_d = responseFromConstructor === null || responseFromConstructor === void 0 ? void 0 : responseFromConstructor.result_sources) === null || _d === void 0 ? void 0 : _d.embeddings_match) === null || _e === void 0 ? void 0 : _e.count) || 0);
            return {
                type: 'products',
                request: requestFromConstructor,
                response: responseFromConstructor,
                results: dataFromConstructor,
                facets: facetsFromConstructor,
                totalResults: totalNumResultsFromConstructor,
            };
        }
        catch (error) {
            console.error('Constructor.io data error:', error);
            return {
                type: 'error',
                error: { message: 'Error getting data from Constructor' },
                totalResults: 0,
            };
        }
    });
}
function constructorGetFacets(_a) {
    return __awaiter(this, arguments, void 0, function* ({ query = '', page = 1, resultsPerPage = 100, filters = {}, sortBy, sortOrder = 'descending', selectedCategory = 'all', isServerSide, userId, }) {
        var _b;
        try {
            const constructorio = isServerSide && typeof window === 'undefined'
                ? (0, createConstructorInstances_1.getConstructorInstanceServerSide)({ userId })
                : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({ userId });
            const slugifiedSelectedCategory = (0, slugify_1.slugify)(selectedCategory);
            const groupIdValue = constants_1.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER[slugifiedSelectedCategory] ||
                slugifiedSelectedCategory;
            const response = query === ''
                ? yield constructorio.browse.getBrowseResults('group_id', groupIdValue, {
                    page,
                    resultsPerPage,
                    filters,
                    sortBy,
                    sortOrder,
                })
                : yield constructorio.search.getSearchResults(query, {
                    page,
                    resultsPerPage,
                    filters,
                    sortBy,
                    sortOrder,
                });
            // console.log('Results Facets:', response)
            // const facetsFromConstructor: ConstructorFacetsResponse = getMockFacets()
            const facetsFromConstructor = 'facets' in response.response ? (_b = response.response) === null || _b === void 0 ? void 0 : _b.facets : [];
            return facetsFromConstructor;
        }
        catch (error) {
            console.error('Constructor.io facets error:', error);
            return [];
        }
    });
}
function constructorGetAutocomplete(_a) {
    return __awaiter(this, arguments, void 0, function* ({ query = '', filters = {}, numResults, isServerSide, userId, }) {
        try {
            const constructorio = isServerSide && typeof window === 'undefined'
                ? (0, createConstructorInstances_1.getConstructorInstanceServerSide)({ userId })
                : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({ userId });
            const response = yield constructorio.autocomplete.getAutocompleteResults(query, {
                filters,
                numResults,
            });
            // console.log(`Autocomplete for ${query} :`, response)
            return {
                request: response.request,
                sections: response.sections,
                totalResultsPerSection: response.total_num_results_per_section,
            };
        }
        catch (error) {
            console.error('Constructor.io data error:', error);
            return {
                request: null,
                sections: {},
                totalResultsPerSection: {},
            };
        }
    });
}
function constructorGetRecommendations(_a) {
    return __awaiter(this, arguments, void 0, function* ({ podId = '', filters = {}, numResults, section = 'Products', isServerSide, userId, itemIds, }) {
        var _b;
        try {
            const constructorio = isServerSide && typeof window === 'undefined'
                ? (0, createConstructorInstances_1.getConstructorInstanceServerSide)({ userId })
                : (0, createConstructorInstances_1.getConstructorInstanceClientSide)({ userId });
            const response = yield constructorio.recommendations.getRecommendations(podId, {
                numResults,
                filters,
                section,
                itemIds,
            });
            // console.log(`Recommendations for ${podId}:`, response)
            return {
                request: response.request,
                response: response.response,
                totalResults: ((_b = response.response) === null || _b === void 0 ? void 0 : _b.total_num_results) || 0,
                resultId: (response === null || response === void 0 ? void 0 : response.result_id) || '',
            };
        }
        catch (error) {
            console.error('Constructor.io data error:', error);
            return {
                request: null,
                response: null,
                totalResults: 0,
                resultId: '',
            };
        }
    });
}
